import { map } from "lodash/fp";

import ROUTES from "@app/common/routes";
import { UserMeeting } from "@app/common/types";

const DEFAULT_INCOMPLETE_DETAILS: IncompleteDetails[] = [
  {
    kind: "unknown",
    message: "There was an unknown issue with this meeting.",
  },
];

export type IncompleteReason = "cancelled" | "opt_out" | "restricted" | "error";

interface IncompleteDetailsSimple {
  kind: string;
  message: string;
}

export interface IncompleteDetailsWithFix extends IncompleteDetailsSimple {
  outcome: string;
  fix: string;
  fixCtaLink: string;
}

export type IncompleteDetails =
  | IncompleteDetailsSimple
  | IncompleteDetailsWithFix;

const INCOMPLETE_REASON_STRING: { [k in IncompleteReason]: string } = {
  cancelled: "Cancelled",
  opt_out: "Opted out",
  restricted: "Restricted Data",
  error: "Error",
};

const INCOMPLETE_DETAILS: {
  [key: IncompleteDetails["kind"]]: Pick<
    IncompleteDetailsWithFix,
    "outcome" | "fix" | "fixCtaLink"
  >;
} = {
  local_recording_setting_disabled: {
    outcome: "Read cannot automatically record",
    fix: "Enable automatic recording for Zoom",
    fixCtaLink: ROUTES.USER_SETTINGS_RECORDING_AND_PLAYBACK,
  },
};

export const getIncompleteReason = (meeting: UserMeeting): IncompleteReason => {
  if (meeting.optOut) return "opt_out";
  if (meeting.state === "cancelled") return "cancelled";
  if (meeting.state === "error") return "error";
  return "restricted";
};

export const getIncompleteReasonDisplayValue = (
  reason: IncompleteReason
): string => {
  return INCOMPLETE_REASON_STRING[reason];
};

export const getIncompleteDetails = (
  meeting: UserMeeting
): (IncompleteDetails | IncompleteDetailsWithFix)[] => {
  if (meeting.alerts.length === 0) {
    return DEFAULT_INCOMPLETE_DETAILS;
  }

  return map((alert) => {
    const details = INCOMPLETE_DETAILS[alert.kind];
    return {
      ...alert,
      ...(details ? details : {}),
    };
  }, meeting.alerts);
};
